<template>
  <section id="faq" style="background-image: url(./img/faq.png)">
    <h2 class="title">{{ $t('faqSection.title') }}</h2>
    <div class="faq-list-wrapper">
      <div class="faq-item pets">
        <div class="faq-question">{{ $t('faqSection.question11') }}</div>
        <div class="faq-answer">
          <p>{{ $t('faqSection.answer11_1') }}</p>
          <p>{{ $t('faqSection.answer11_2') }}</p>
          <p>{{ $t('faqSection.answer11_3') }}</p>
          <p>{{ $t('faqSection.answer11_4') }}</p>
          <p>{{ $t('faqSection.answer11_5') }}</p>
          <p>{{ $t('faqSection.answer11_6') }}</p>
          <ul>
            <li>{{ $t('faqSection.answer11_7') }}</li>
            <li>{{ $t('faqSection.answer11_8') }}</li>
            <li>{{ $t('faqSection.answer11_9') }}</li>
          </ul>
        </div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question1') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer1') }}</div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question2') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer2') }}</div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question3') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer3') }}</div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question4') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer4') }}</div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question5') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer5') }}</div>
      </div>
      <!--      <div class="faq-item">-->
      <!--        <div class="faq-question">{{ $t('faqSection.question6') }}</div>-->
      <!--        <div class="faq-answer">{{ $t('faqSection.answer6') }}</div>-->
      <!--      </div>-->
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question7') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer7') }}</div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question8') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer8') }} &nbsp; <a href="tel:+380487352060">+38 (048) 735 20
          60</a></div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question9') }}</div>
        <div class="faq-answer">{{ $t('faqSection.answer9') }}</div>
      </div>
      <div class="faq-item">
        <div class="faq-question">{{ $t('faqSection.question10') }}</div>
        <div class="faq-answer">
          {{ $t('faqSection.answer10_1') }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Faq'
}
</script>

